export default "__VITE_ASSET__Bth2Vr_3__"